import Locale from './Locale';

export default Locale;
export { Locale };
